import { getZrmListingInfo, getZrmUserInfo } from '@zg-rentals/clickstream';

import { DEFAULT_ENVELOPE_BLOCK, TRIGGER_LOCATIONS, TRIGGER_TYPE } from '../../constants/ClickstreamConstants';
import { trackEvent } from '../index';

import type { ZrmClickstreamListing, ZrmClickstreamUser } from '@zg-rentals/clickstream';

export const EVENT_IDS = {
  PROOF_OF_INSURANCE_SEND_REQUEST: '7745',
  PROOF_OF_INSURANCE_REQUEST_CLICK: '7746',
} as const;

export const PROOF_OF_INSURANCE_CS_TRIGGER_OBJECTS = {
  TENANT_CARD: TRIGGER_LOCATIONS.TENANT_CARD,
  RECOMMENDED_ACTIONS: TRIGGER_LOCATIONS.RECOMMENDED_ACTIONS,
};

// https://dataportal.zillowgroup.net/event-registry/7745
export const emitProofOfInsuranceSendRequestEvent = ({
  triggerLocation = PROOF_OF_INSURANCE_CS_TRIGGER_OBJECTS.TENANT_CARD,
  currentProperty,
  user,
}: {
  triggerLocation: (typeof PROOF_OF_INSURANCE_CS_TRIGGER_OBJECTS)[keyof typeof PROOF_OF_INSURANCE_CS_TRIGGER_OBJECTS];
  currentProperty: ZrmClickstreamListing;
  user: ZrmClickstreamUser;
}) =>
  trackEvent.listingUser({
    envelope: {
      event_type_id: EVENT_IDS.PROOF_OF_INSURANCE_SEND_REQUEST,
      ...DEFAULT_ENVELOPE_BLOCK,
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.INTERACTION,
      trigger_location_nm: TRIGGER_LOCATIONS.PROPERTY_OVERVIEW,
      trigger_source_nm: 'send_request',
      trigger_object_nm: triggerLocation,
    },
    semantic: {
      semantic_event_nm: 'send_request_poi',
      topic_tag_txt: [],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });
